import { useState, useEffect, useMemo } from 'react';
import { formatSmartDate, formatFullDateTime } from '../utils/timeUtils';

/**
 * Hook that returns a smart date display string and a full date/time for tooltips.
 * Auto-updates periodically to keep relative times fresh.
 *
 * @param {number|string|Date} timestamp - The timestamp to format
 * @param {number} updateInterval - How often to update in ms (default: 60000 = 1 minute)
 * @returns {{ display: string, fullDateTime: string }}
 */
export function useTimeAgo(timestamp, updateInterval = 60000) {
  const [display, setDisplay] = useState(() => formatSmartDate(timestamp));

  useEffect(() => {
    setDisplay(formatSmartDate(timestamp));

    const interval = setInterval(() => {
      setDisplay(formatSmartDate(timestamp));
    }, updateInterval);

    return () => clearInterval(interval);
  }, [timestamp, updateInterval]);

  // Full date/time is stable (doesn't change over time), compute once
  const fullDateTime = useMemo(() => formatFullDateTime(timestamp), [timestamp]);

  return { display, fullDateTime };
}
